import { render, staticRenderFns } from "./registerStep2.vue?vue&type=template&id=0f9b66fe&scoped=true"
import script from "./registerStep2.vue?vue&type=script&lang=js"
export * from "./registerStep2.vue?vue&type=script&lang=js"
import style0 from "./registerStep2.vue?vue&type=style&index=0&id=0f9b66fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b66fe",
  null
  
)

export default component.exports